import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ChartContainer = styled.div`
	width: ${props => props.width};
	position: relative;

	.line-chart {
		.highcharts-markers path {
			fill: ${colors.white};
		}
	}
`;

export const LegendContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	margin-top: 12px;
	visibility: ${props => (props.isHidden ? 'hidden' : 'visible')};
`;

export const LegendItem = styled.div`
	display: flex;
	align-items: center;
	margin-left: 24px;
	margin-bottom: 8px;
`;

export const LegendColor = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	width: 21px;
	height: 16px;
`;
export const LegendColorLine = styled.div`
	width: 21px;
	height: 1px;
	border-radius: 1px;
	background-color: ${props => props.color};
`;

export const LegendColorDot = styled.div`
	position: absolute;
	left: 7px;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	border: 1px solid ${colors.white};
	background-color: ${props => props.color};
`;

export const LegendName = styled.div`
	font-size: 11px;
	color: ${colors.grey8};
	margin-left: 8px;
`;

export const LegendTitle = styled.div`
	line-height: 24px;
	font-size: 16px;
`;

export const SelectedBackgroundContainer = styled.div`
	position: relative;
`;

export const SelectedBackground = styled.div`
	position: absolute;
	background: #444444;
	opacity: 0.05;
	z-index: 1;
`;

export const TooltipContainer = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 8px 12px;
	margin: 0;
	z-index: 2;
	background-color: ${colors.white};
`;

export const TooltipColor = styled.span`
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 4px;
	margin-right: 8px;
	background-color: ${props => props.color || 'transparent'};
`;

export const TooltipItem = styled.li`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 13px;
`;

export const TooltipItemName = styled.span`
	text-transform: capitalize;
`;

export const TooltipItemValue = styled.strong`
	margin-left: 12px;
`;

export const TooltipItemTitle = styled.strong`
	font-size: 13px;
	font-weight: bold;
	margin: 0 auto 8px;
`;

export const TooltipItemLabel = styled.span`
	width: 95px;
	font-size: 11px;
	font-weight: 300;
	color: ${colors.grey5};
`;
